import { AiFillAppstore } from "react-icons/ai";
import { FaAlgolia, FaJava, FaLinkedinIn, FaReact, FaPython, FaGitAlt, FaDocker } from "react-icons/fa";
import { SiTailwindcss, SiDjango, SiMongodb, SiRust, SiMysql, SiSpringboot } from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <SiSpringboot />,
    title: "Spring Boot",
    des: "I specialize in Spring Boot and have built robust backend applications using it. I have worked on REST APIs, microservices, and enterprise applications, ensuring scalability and efficiency.",
  },
  {
    id: 2,
    icon: <FaReact />,
    title: "ReactJS",
    des: "I specialize in ReactJS, building dynamic and responsive user interfaces. I have experience working with React hooks, state management (Redux, Context API), and component-based architecture to create scalable and efficient frontend applications.",
  },
  {
    id: 3,
    icon: <SiDjango />,
    title: "Django",
    des: "I specialize in Django, developing scalable and secure backend applications. I have experience building RESTful APIs, authentication systems, and database-driven applications using Django’s powerful ORM and MVC architecture. ",
  },
  // {
  //   id: 4,
  //   icon: <FaMobile />,
  //   title: "Mobile Development",
  //   des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque solutahic consequuntur eum repellendus ad",
  // },
  {
    id: 4,
    icon: <FaPython />,
    title: "Python",
    des: "I specialize in Python, leveraging its versatility for backend development, automation, data structures & algorithms, and scripting. I have built scalable applications using Python frameworks like Django and have experience working with APIs, databases, and data processing.",
  },
  {
    id: 5,
    icon: <SiMysql />,
    title: "MySQL",
    des: "I specialize in MySQL, utilizing its powerful relational database management system (RDBMS) features for building scalable and efficient applications. I have experience in writing complex queries, indexing, optimizing performance, and managing data integrity to ensure seamless database operations.",
  },
  {
    id: 5,
    icon: <FaDocker />,
    title: "Docker",
    des: "I specialize in Docker, using containerization to deploy and manage applications efficiently. I have experience in writing Dockerfiles, creating Docker Compose setups, managing multi-container environments, and optimizing containerized applications for scalability and portability.",
  },
  {
    id: 5,
    icon: <SiRust />,
    title: "Rust",
    des: "I specialize in Rust, leveraging its memory safety, performance, and concurrency features to build reliable and efficient systems. I have experience working with Rust for system programming, backend development, and performance-critical applications, ensuring safety without a garbage collector.",
  },
  {
    id: 5,
    icon: <FaGitAlt />,
    title: "Git",
    des: "I specialize in Git, utilizing it for version control, collaborative development, and efficient code management. I have experience with branching strategies, Git workflows (Git Flow, GitHub Flow), resolving merge conflicts, and working with platforms like GitHub, GitLab, and Bitbucket to streamline development.",
  },
];
